import { module } from 'modujs';
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                goTo: 'goTo'
            }
        }
    }

    init() {
        if (!this.el.querySelector('.swiper')) return;

        this.lastIndex = 0;
        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 'auto',
            speed: 600,
            on: {
                init: () => {;
                    let firstDescription = this.el.querySelector('.c-timeline_description[data-index="0"]');
                    if (firstDescription) {
                        let b = firstDescription.getBoundingClientRect();
                        gsap.set('.c-timeline_descriptions', { height: b.height + 'px' });
                    }

                    window.addEventListener("resize",() => {
                        let currentDescription = this.el.querySelector('.c-timeline_description[data-index="' + this.swiper.activeIndex + '"]');
                        if (currentDescription) {
                            let b = currentDescription.getBoundingClientRect();
                            gsap.to('.c-timeline_descriptions', { height: b.height + 'px' });
                        }
                    });
                },
                slideChange: () => {
                    let modifier = 1;
                    if (this.lastIndex > this.swiper.activeIndex) {
                        modifier = -1;
                    }

                    let oldDescription = this.el.querySelector('.c-timeline_description[data-index="' + this.lastIndex + '"]');
                    let currentDescription = this.el.querySelector('.c-timeline_description[data-index="' + this.swiper.activeIndex + '"]');

                    if (oldDescription) {
                        gsap.killTweensOf(oldDescription);
                        gsap.fromTo(
                            oldDescription,
                            { autoAlpha: 1, x: 0 },
                            { autoAlpha: 0, x: modifier * -30 + '%', duration: 0.3, ease: 'power3.out'},
                        );
                    }

                    if (currentDescription) {
                        gsap.killTweensOf(currentDescription);
                        let b = currentDescription.getBoundingClientRect();
                        
                        gsap.fromTo(
                            currentDescription,
                            { autoAlpha: 0, x: modifier * 30 + '%' },
                            { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power3.out'},
                        );

                        gsap.to('.c-timeline_descriptions', { height: b.height + 'px', duration: 0.6, ease: 'power3.out'});
                    }

                    this.lastIndex = this.swiper.activeIndex;
                }
            },
            freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.1,
            },
            modules: [FreeMode],
        });
    }

    goTo(e) {
        e.preventDefault();
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        this.swiper.slideTo(index);
    }
}
